import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faTimer, faCircleArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { PaymentStatus as PaymentStatusEnum } from 'shared/models/enums/PaymentStatus';
import sctheme from 'app/styles/sctheme';
export type PaymentStatusProps = {
  status: any;
};

export function PaymentStatus(props: PaymentStatusProps) {
  const { status } = props;
  switch (status) {
    case PaymentStatusEnum.Pending:
    case 0:
      return (
        <div>
          <FontAwesomeIcon className="text-warning mr-2" icon={faTimer} />
          Pending
        </div>
      );
    case PaymentStatusEnum.Succeeded:
    case 1:
      return <div>Successful</div>;
    case PaymentStatusEnum.Failed:
    case 2:
      return (
        <div>
          <FontAwesomeIcon className="text-danger mr-2" icon={faCircleExclamation} />
          Failed
        </div>
      );
    case PaymentStatusEnum.Refunded:
    case 3:
      return (
        <div>
          <FontAwesomeIcon style={{ color: sctheme.grays.$500 }} className="mr-2" icon={faCircleArrowLeft} />
          Refunded
        </div>
      );
    case PaymentStatusEnum.Disputed:
    case 4:
      return (
        <div>
          <FontAwesomeIcon className="text-danger mr-2" icon={faCircleExclamation} />
          Disputed
        </div>
      );
    case PaymentStatusEnum.Blocked:
    case 5:
      return (
        <div>
          <FontAwesomeIcon className="text-danger mr-2" icon={faCircleExclamation} />
          Blocked
        </div>
      );
    case PaymentStatusEnum.PartiallyRefunded:
    case 6:
      return (
        <div>
          <FontAwesomeIcon style={{ color: sctheme.grays.$500 }} className="mr-2" icon={faCircleArrowLeft} />
          Partially Refunded
        </div>
      );
    case null:
    default:
      return <div></div>;
  }
}
